<template>
    <div class="Withdrawal">
        <el-form :inline="true" :model="queryInfo" class="form" style="margin-bottom: -10px;">
            <el-row :gutter="24">
                <el-col>
                    <el-form-item label="真实姓名">
                        <el-input v-model="queryInfo.trueName" @change="getVinAccountList" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="queryInfo.type" placeholder="请选择类型" @change="getVinAccountList" filterable>
                            <el-option v-for="(item, index) in VinAll" :key="index" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间：">
                        <el-date-picker type="datetimerange" @blur="pickBlur" :picker-options="pickerOptions"
                            v-model="values" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                            @change="data_change">
                        </el-date-picker></el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-card>
            <el-table :data="ListTil" border>
                <el-table-column label="商户名称" prop="merchantMame" :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.merchantMame }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="真实姓名" prop="trueName">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.trueName }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="手机号" prop="phone" width="110">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.phone }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="入账金额" prop="changeMoney" width="94">
                    <template slot-scope="scope">
                        <span>
                            ￥{{ jisuan(scope.row.changeMoney, 100, 2) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="提现金额" prop="changeMoney" width="94">
                    <template slot-scope="scope">
                        <span>
                            ￥{{ jisuan(scope.row.realityMoney, 100, 2) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="账户余额" prop="newMoney" width="120">
                    <template slot-scope="scope">
                        <span style="color:red">
                            ￥ {{ jisuan(scope.row.newMoney, 100, 2) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="提现方式" prop="withdrawalType" width="90">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.withdrawalType == 0 ? '人工转账' : '自动转账' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.updateTime !== '' ? scope.row.updateTime : '---' }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.page" :page-sizes="[6, 20, 50, 100]" :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background>
            </el-pagination>
        </el-card>
    </div>
</template>
<script>
export default {
    name: 'Withdrawal',
    data() {
        return {
            typesIng: 0,
            values: ['', ''],
            formtypelist: [0, 1, 2, 3, 4],
            VinAll: [
                {
                    label: '提现',
                    value: 0
                },
                {
                    label: '入账',
                    value: 1
                }, {
                    label: '补差',
                    value: 2
                }, {
                    label: '分账失败',
                    value: 3
                },
            ],
            startRcord: 0,
            pickerMinDate: '',
            pickerMinDate2: '',
            daochuDialoag: false,
            pickerOptions: {
                onPick: obj => {
                    this.pickerMinDate = new Date(obj.minDate).getTime()
                    const start = this.formatDate(obj.minDate, 'start')
                    const end = this.formatDate(obj.maxDate, 'end')
                    obj.maxDate && (this.value1 = [start, end])
                },
                disabledDate: time => {
                    if (this.pickerMinDate) {
                        const oneMonth = 1000 * 3600 * 24 * 31
                        const maxTime = this.pickerMinDate + oneMonth
                        const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
                        const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
                        return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
                    }
                }
            },
            pickerOptions2: {
                onPick: obj => {
                    this.pickerMinDate2 = new Date(obj.minDate).getTime()
                    const start = this.formatDate(obj.minDate, 'start')
                    const end = this.formatDate(obj.maxDate, 'end')
                    obj.maxDate && (this.value1 = [start, end])
                },
                disabledDate: time => {
                    if (this.pickerMinDate2) {
                        const oneMonth = 1000 * 3600 * 24 * 31
                        const maxTime = this.pickerMinDate2 + oneMonth
                        const mixTime = this.pickerMinDate2 - oneMonth + 1000 * 3600 * 24
                        const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
                        return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
                    }
                }
            },
            formobj: {
                stationLedgerId: null,
                type: 0,
                startTime: null,
                endTime: null,
            },
            expendTotal: 0,
            rzType: false,
            czType: false,
            zhangdanInfo: {
                stationLedgerId: null,
                page: 1,
                limit: 8
            },
            expendList: [],
            expendDialogVisible: false,
            bianji: false,
            yuyuetixian: false,
            wxsq: 0,
            sjdz: 0,
            num: 1000,
            // 000
            yuyuemoney: 0,
            cashOutDialogVisible: false,
            settlementForm: {
                adminId: '',
                type: 0,
                trueName: '',
                bankCode: '',
                bankName: '',
                openId: '',
                status: 0,
                wechatId: '',
                phone: '',
                bankCard: '',
                serviceRate: '',
                powerStationId: 0,
                stationIds: '',
                money: 0,
                type: 0,
                des: '',
                merchantName: '',
            },
            settlementRules: {
                merchantName: [
                    { required: true, message: '请至少选择一项', trigger: 'change' }
                ],
                type: [
                    { required: true, message: '请选择你的收费类型', trigger: 'change' }
                ],
                adminId: [
                    { required: true, message: '请输入商户名称', trigger: 'change' }
                ],
                trueName: [
                    { required: true, message: '真实姓名不能为空', trigger: 'blur' },
                ],
                bankName: [
                    { required: true, message: '银行名称不能为空', trigger: 'blur' }
                ],
                openId: [
                    { required: true, message: '收款openId不能为空', trigger: 'blur' }
                ],
                wechatId: [
                    { required: true, message: '请至少选择一项', trigger: 'change' }
                ],
                phone: [
                    { required: true, message: '电话号码不能为空', trigger: 'blur' },
                ],
                bankCard: [
                    { required: true, message: '银行卡号不能为空', trigger: 'blur' },
                ],
                serviceRate: [
                    { required: true, message: '费率不能为空', trigger: 'blur' },
                ]
            },
            stationIds: '',
            ds: '',
            allshanghu: [],
            stationList: [],
            typelist: [{
                id: 0,
                name: '服务费'
            },
            {
                id: 1,
                name: '全额消费'
            },
            {
                id: 2,
                name: '全额电费'
            }],
            radio: '是',
            leaavel: [
                {
                    name: '是'
                },
                {
                    name: '否'
                }
            ],
            title: '',
            vinAccountFormRules: {
                trueName: {
                    required: true, message: '请输入真实姓名', trigger: 'blur'
                },
                merchantName: {
                    required: true, message: '请输入商户名称', trigger: 'blur'
                },
                type: {
                    required: true, message: '请选择收费类型', trigger: 'change'
                },
                serviceRate: {
                    required: true, message: '请输入或选择费率', trigger: 'blur'
                },
                phone: {
                    required: true, message: '请输入联系电话', trigger: 'blur'
                },
                adminId: {
                    required: true, message: '请选择提现商户', trigger: 'change'
                },
                // stationId: {
                //   required: true, message: '请选择所属电站', trigger: 'change'
                // },
                bankCard: {
                    required: true, message: '请输入收款卡号', trigger: 'blur'
                },
                bankName: {
                    required: true, message: '请输入收款银行', trigger: 'blur'
                },
                userName: {
                    required: true, message: '请输入登录账户', trigger: 'blur'
                },
                passWord: {
                    required: true, message: '请输入登录密码', trigger: 'blur'
                }
            },
            vinAccountForm: {
                passWord: '',
                userName: '',
                adminId: '',
                trueName: '',
                id: '',
                bankCard: '',
                bankName: '',
                type: 0,
                serviceRate: 0,
                des: '',
                isMainAccount: '1',
                freezeMoney: '',
                totalLedgerId: '',
                stationId: '',
                status: 0
            },
            editDialogVisible: false,
            coolDialoag: false,
            //提现
            typeobj: {

            },
            freezeMoney: '',
            name: '人工转账',
            total2: 0,
            checkIndex: 0,
            btn1: false,
            // 明细表
            carinfo: {
                page: 1,
                limit: 8,
                stationLedgerId: '',
                roleId: window.sessionStorage.getItem('roleId'),
                type: 3
            },
            listname: [],
            title: '本月清分入账明细',
            titleDialoag1: false,
            titleDialoag2: false,
            suoshudianzhan: '',
            powerStationList: [],
            leaavelz: [
                '人工转账', '自动转账'
            ],
            ListTil: [],
            stopMoney: false,
            currentobj: {
                money1: 0,
                money2: 0
            },
            tabList: [],
            typing: false,
            listobj: {},
            queryInfo: {
                page: 1,
                limit: 6,
                type: 0,
                isUpdata: 1,
                sortType: 1
            },
            tilobj: {
                page: 1,
                limit: 150,
                adminId: window.sessionStorage.getItem('adminId'),
                roleId: window.sessionStorage.getItem('roleId'),
                merchantName: ''
            },
            leixing: false,
            obj: {

            },
            value1: ['', ''],
            OrderLoag: false,
            loading: false,
            total: 0,
            startTime: '',
            endTime: '',
            status: true
        }
    },
    computed: {
        shiji() {
            return function (abc, bac) {
                return (((abc * 1) + (bac * 1)) / 100).toFixed(2)
            }
        },
        wait_s() {
            return function (e) {
                return ((e.money - e.giveMoney) / 100).toFixed(2)
            }
        },
        time_all() {
            return function (val) {
                const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
                return hr
            }
        },
        jisuan() {
            return function (obj, num, fixed) {
                if (obj == null || obj == undefined) return '--';
                return (obj / num).toFixed(fixed)
            }
        },
        shifu() {
            return function (val) {
                return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
            }
        }
    },
    created() {
        this.getVinAccountList();
    },
    methods: {
        pickBlur2() {
            this.pickerMinDate2 = ''
        },
        changeTime2(value) {
            if (value) {
                this.formobj.startTime = value[0];
                this.formobj.endTime = value[1];
                if (this.formobj.startTime == this.formobj.endTime) {
                    this.$message.error('起始时间不得为同一天！');
                    this.formobj.startTime = ''
                    this.formobj.endTime = ''
                }
            } else {
                this.formobj.startTime = null
                this.formobj.endTime = null
                this.pickerMinDate2 = '';
            }
        },
        formatDate(datetime, type) {
            const time = new Date(datetime)
            const year = time.getFullYear()
            const month = (time.getMonth() + 1).toString().padStart(2, '0')
            const date = (time.getDate()).toString().padStart(2, '0')
            return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
        },
        getDate() {
            const start = new Date()
            this.values[0] = this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30, 'start')
            this.values[1] = this.formatDate(start.getTime(), 'end')
        },
        closeMethods() {
            this.daochuDialoag = false;
            this.values = ['', ''];
            this.formobj.type = 0;
            this.formobj.startTime = null;
            this.formobj.endTime = null;
        },
        // 更新日期
        formatDate(datetime, type) {
            const time = new Date(datetime)
            const year = time.getFullYear()
            const month = (time.getMonth() + 1).toString().padStart(2, '0')
            const date = (time.getDate()).toString().padStart(2, '0')
            return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
        },
        // 修改最小日期
        pickBlur() {
            this.pickerMinDate = ''
        },
        data_change(e) {
            if(!e||e==''){
                          this.queryInfo.startTime = '';
                this.queryInfo.endTime = '';
            }else{
                  if (e.length > 0) {
                this.queryInfo.startTime = e[0];
                this.queryInfo.endTime = e[1];
                if (this.queryInfo.startTime == this.queryInfo.endTime) {
                    this.$message.error('起始时间不得为同一天！');
                    this.queryInfo.startTime = ''
                    this.queryInfo.endTime = ''
                }}
            }
            this.getVinAccountList()
        },
        chu(e) {
            this.OrderLoag = true;
            this.startRcord = e;
        },
        qx_dialoag() {
            this.OrderLoag = false;
            this.value1 = ['', ''];
            this.startTime = '';
            this.endTime = '';
        },

        // 获取vin用户列表
        async getVinAccountList() {
            const that = this;
            const {type}=that.queryInfo;
            if(type==1||type==3){
                that.queryInfo.isUpdata=0;
            }
            if(!that.queryInfo.trueName||that.queryInfo.trueName==''){
                that.$delete(that.queryInfo,'trueName')
            }
            await that.$http.get('station-ledger-log/getAllStationLedgerLogByStore', { params: that.queryInfo }).then(res => {
                that.total = res.data.count;
                that.ListTil = res.data.data;
            })
        },
        // 监听pageSize改变的事件
        handleSizeChange(newSize) {
            this.queryInfo.limit = newSize;
            this.queryInfo.page = 1;
            this.getVinAccountList()
        },
        // 监听页码值改变的事件
        handleCurrentChange(newPage) {
            this.queryInfo.page = newPage;
            this.getVinAccountList()
        }
    }
};
</script>

<style lang="less" scoped>
.listnames {
    display: flex;
    flex-direction: row;
    height: 120px;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 20px;
    border: 1px solid gray;
    list-style: none;
    border-radius: 15px;

    .dl {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: 20px;

        p {
            flex: 1;
            display: flex;
            justify-content: center;
            font-size: 18px;
        }

        p:nth-child(1) {
            color: gray;
            font-size: 16px;
        }

    }

    .dl:last-child {
        margin-right: 0;
    }
}

.Withdrawal {
    width: 97%;
    height: 100%;
    padding-bottom: 100px;
    margin: 0 2% 100px 1%;

    .cool {
        display: flex;
        flex-direction: column;

        p {
            display: flex;
            flex-direction: row;
            line-height: 20px;
        }

        p:nth-child(1) {
            align-items: center;

            span {
                margin-right: 10px;
            }
        }

        p:nth-child(2) {
            justify-content: center;
            align-items: center;
        }

        p:nth-child(5) {
            justify-content: center;

            button {
                width: 120px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;

                border: 1px solid #c5c5c5;
                font-size: 16px;
                border-radius: 5px;
                background: none;

            }

            button:nth-child(2) {
                margin-left: 20px;
                background: #13ce66;
                border: none;
                color: #fff;
            }
        }
    }

    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: -10px;

        h4 {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 16px;

            span {
                margin-right: 10px;
            }
        }
    }

    .center {
        width: 100%;
        height: 200px;

        h4 {
            height: 30px;
            display: flex;
            align-items: center;

            span {
                font-size: 18px;
            }
        }

        .ceil {
            height: 100%;
            display: flex;
            flex-direction: column;

            li {
                display: flex;
                flex-direction: row;
                font-size: 18px;

                dl {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                }
            }

            li:nth-child(1) {
                flex: 4;
                margin-bottom: 10px;

                dl {
                    height: 100%;

                    dt,
                    dd {
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        // align-items: center;
                    }

                    dt {
                        font-size: 24px;
                        font-weight: bolder;
                    }
                }

                dl:nth-child(5) {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    button {
                        width: 120px;
                        height: 30px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #fff;
                        background-color: blue;
                    }
                }

                dl:nth-child(4) {
                    dd {
                        margin-left: -1%;
                        color: blue;
                    }
                }
            }

            li:nth-child(2) {
                flex: 6;
                border: 1px solid gray;
                border-radius: 15px;


                dt,
                dd {
                    display: flex;
                    justify-content: center;

                }

                dt {
                    flex: 1;
                    align-items: center;
                }

                dd {
                    flex: 9;
                    flex-direction: column;

                    span {
                        flex: 1;

                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    span:nth-child(1) {
                        padding: 10px 0;
                    }
                }
            }
        }
    }
}
</style>